import { render, staticRenderFns } from "./seach.vue?vue&type=template&id=51f5d786&scoped=true"
import script from "./seach.vue?vue&type=script&lang=js"
export * from "./seach.vue?vue&type=script&lang=js"
import style0 from "./seach.vue?vue&type=style&index=0&id=51f5d786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5d786",
  null
  
)

export default component.exports